import { type ComponentProps } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxChipProps extends PartProps<ComponentProps<typeof Combobox.Chip>> {
  className?: string
}

function ComboboxChip({ className, children, ...props }: ComboboxChipProps) {
  return (
    <Combobox.Chip
      className={twMerge(
        'corner-smooth inline-flex items-center gap-1 rounded-lg px-2 py-1',
        'text-xs font-medium transition-colors',
        'bg-element-hover text-foreground-secondary border-border border',
        className,
      )}
      {...props}
    >
      {children}
    </Combobox.Chip>
  )
}

export { ComboboxChip }
